import {
  createStickerRewardScreenModel,
  type StickerRewardScreenProps,
} from './StickerRewardScreenModelScreen';
import { StickerRewardScreenController } from './StickerRewardScreenController';
import { StickerRewardScreenView } from './StickerRewardScreenView';

export type { StickerRewardScreenProps } from './StickerRewardScreenModelScreen';

export function StickerRewardScreen(props: StickerRewardScreenProps) {
  const model = createStickerRewardScreenModel(props);
  const controller = new StickerRewardScreenController(model);

  return <StickerRewardScreenView model={model} controller={controller} />;
}
